import {IRoomRunFile} from '../../../incase-domain/proptypes/IRoomRunFile';
import {IResetRunfile} from './runfile.actions.types';
import {IFetchRoom} from '../../../incase-domain/rooms/room.player';
import {GuestCredentials} from '../../../components/presentationView/parts/components/GuestModal';

export const UPDATE_ROOM_RUN_FILE = 'UPDATE_ROOM_RUN_FILE';
export const UPDATE_CURRENT_OWNER_SLIDE = 'UPDATE_CURRENT_OWNER_SLIDE';
export const FIND_ROOM_BY_ID = 'FIND_ROOM_BY_ID';
export const UPDATE_ROOM_REDUCER = 'UPDATE_ROOM_REDUCER';
export const UPDATE_ROOM_USER_COUNT = 'UPDATE_ROOM_USER_COUNT';

export interface IUpdateRoomUserCount {
    type: typeof UPDATE_ROOM_USER_COUNT;
    payload: number;
}

export interface IFindRoomByIdAction {
    type: typeof FIND_ROOM_BY_ID;
    payload: {roomId: string; credential?: GuestCredentials; params?: Record<string, string>; hash?: string; presenterCode?: string};
}

export interface IUpdateRoomReducerAction {
    type: typeof UPDATE_ROOM_REDUCER;
    room: IFetchRoom;
}

export interface IUpdateRoomRunFileAction {
    type: typeof UPDATE_ROOM_RUN_FILE;
    roomRunFile: IRoomRunFile;
}

export interface IUpdateCurrentOwnerSlideAction {
    type: typeof UPDATE_CURRENT_OWNER_SLIDE;
    slideIndex: number;
}

export type RoomRunFileReducerType =
    | IUpdateRoomRunFileAction
    | IFindRoomByIdAction
    | IUpdateCurrentOwnerSlideAction
    | IUpdateRoomReducerAction
    | IResetRunfile
    | IUpdateRoomUserCount;
